import React from 'react';
import { Users, FileText, DollarSign, Shield, ShieldAlert } from 'lucide-react';

export const StatCards = ({ stats, programStats }) => {
  const cards = [
    { icon: <Users size={24} color="#F67425" />, val: stats?.totalUsers || 0, label: 'Users' },
    { icon: <FileText size={24} color="#F67425" />, val: stats?.totalAssessments || 0, label: 'Assessments' },
    { icon: <Shield size={24} color="#10B981" />, val: programStats?.verified || 0, label: 'Verified Programs' },
    { icon: <ShieldAlert size={24} color="#D97706" />, val: programStats?.unverified || 0, label: 'Unverified' },
    { icon: <DollarSign size={24} color="#10B981" />, val: `$${stats?.totalRevenue || 0}`, label: 'Revenue' },
  ];

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '1rem', marginBottom: '2rem' }}>
      {cards.map((s) => (
        <div key={s.label} className="card" style={{ padding: '1.25rem' }} data-testid={`stat-card-${s.label}`}>
          <div style={{ marginBottom: '0.75rem', opacity: 0.9 }}>{s.icon}</div>
          <div style={{ fontSize: '1.75rem', fontWeight: 700, marginBottom: '0.25rem' }} className="gradient-text">{s.val}</div>
          <div style={{ fontSize: '0.8125rem', color: 'var(--text-muted)' }}>{s.label}</div>
        </div>
      ))}
    </div>
  );
};
